import React, { useEffect, useState } from "react";

const containerStyle = {
  paddingTop: "20px",
  paddingBottom: "20px",
};

const sectionStyle = {
  borderRadius: "10px",
  backgroundColor: "#f9f9f9",
  padding: "20px",
  boxShadow: "0 0 10px 1px rgba(0, 0, 0, 0.3)",
  marginBottom: "20px",
  overflow: "hidden",
  width: "100%",
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginTop: "10px",
  tableLayout: "fixed",
  wordWrap: "break-word",
};

const thStyle = {
  backgroundColor: "#f1f1f1",
  fontWeight: "700",
  border: "1px solid #ddd",
  padding: "8px",
  textAlign: "center",
};

const thStyleRight = {
  fontWeight: "700",
  backgroundColor: "#f1f1f1",
  border: "1px solid #ddd",
  padding: "8px",
  textAlign: "right",
};

const thStyleLeft = {
  backgroundColor: "#f1f1f1",
  fontWeight: "bold",
  border: "1px solid #ddd",
  padding: "8px",
  textAlign: "left",
};

const tdStyle = {
  border: "1px solid #ddd",
  padding: "8px",
  textAlign: "center",
};

const tdStyleRight = {
  border: "1px solid #ddd",
  padding: "8px",
  textAlign: "right",
  width: "50%",
};

const tdStyleRight25 = {
  border: "1px solid #ddd",
  padding: "8px",
  textAlign: "right",
  width: "25%",
};

const tdStyleLeft25 = {
  border: "1px solid #ddd",
  padding: "8px",
  textAlign: "left",
  width: "25%",
};

const tdStyleLeft = {
  border: "1px solid #ddd",
  padding: "8px",
  textAlign: "left",
  width: "50%",
};

const tdStyle25 = {
  border: "1px solid #ddd",
  padding: "8px",
  textAlign: "center",
  width: "25%",
};

const titleStyle = {
  justifyContent: "center",
  textAlign: "center",
  alignItems: "center",
  fontSize: "20px",
  color: "#2084e9",
};

const totalStyle = {
  backgroundColor: "#d6ebff",
  fontWeight: "bold",
  border: "1px solid #ccc",
  padding: "8px",
  width: "33.33%",
  textAlign: "center",
};

const GetReport = () => {
  // Add print styles
  useEffect(() => {
    const printStyles = `
      @media print {
        @page {
          size: A3;
          margin: 0.5in;
        }
        body {
          font-size: 12px;
        }
        table {
          page-break-inside: avoid;
          width: 100% !important;
          table-layout: fixed !important;
          word-wrap: break-word;
        }
        th, td {
          font-size: 10px !important;
          padding: 4px !important;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .section-container {
          page-break-inside: avoid;
          overflow: hidden;
        }
        .printBtn {
          display: none !important;
        }
      }
    `;
    
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);
    
    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  const [printData, setPrintData] = useState();
  
  useEffect(() => {
    setPrintData(JSON.parse(localStorage.getItem("printDailyReport")));
  }, []);

  const [print, setPrint] = useState(false);
  
  const proceedPrint = () => {
    setPrint(true);
    setTimeout(() => window.print(), 500);
  };

  return printData !== undefined ? (
    <div style={{ padding: "20px", backgroundColor: "#f2f2f2" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: "10px",
            width: "100%",
            height: "40px",
            padding: "20px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
            background: "#ffffff",
          }}
        >
          <h6 style={{ margin: 0, fontWeight: "bold" }}>
            {printData.store_name}
          </h6>
          <h6 style={{ margin: 0, fontWeight: "bold" }}>
            Shift: {printData.shift}
          </h6>
          <h6 style={{ margin: 0, fontWeight: "bold" }}>
            Report Date: {printData.date}
          </h6>
        </div>
      </div>
      
      {!print ? (
        <button
          onClick={() => {
            proceedPrint();
          }}
          style={{ position: "fixed", right: "10px", top: "50px" }}
          className="btn btn-success printBtn"
        >
          {" "}
          <i className="fa fa-print"></i> Print (A3 Page)
        </button>
      ) : (
        ""
      )}

      <div style={containerStyle}>
        <div style={sectionStyle} className="section-container">
          <h3 style={titleStyle}>🎰 DAILY LOTTERY REPORT</h3>
          
          <br />
          <h3 style={titleStyle}>📗 ACTIVATED BOOKS</h3>
          <div style={{ overflowX: "auto" }}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Game Number</th>
                  <th style={thStyle}>Book Number</th>
                  <th style={thStyle}>Count</th>
                  <th style={thStyle}>Value</th>
                </tr>
              </thead>
              <tbody>
                {printData.activated_books !== undefined
                  ? printData.activated_books.map((book, index) => (
                      <tr key={index}>
                        <td style={tdStyle25}>{book.game_no}</td>
                        <td style={tdStyle25}>{book.book_no}</td>
                        <td style={tdStyle25}>{book.count}</td>
                        <td style={tdStyle25}>{book.value}</td>
                      </tr>
                    ))
                  : ""}
              </tbody>
            </table>
          </div>

          <br />
          <h3 style={titleStyle}>📕 RETURNED BOOKS</h3>
          <div style={{ overflowX: "auto" }}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Game Number</th>
                  <th style={thStyle}>Ticket Number</th>
                  <th style={thStyle}>Value</th>
                </tr>
              </thead>
              <tbody>
                {printData.returned_books !== undefined
                  ? printData.returned_books.map((book, index) => (
                      <tr key={index}>
                        <td style={tdStyle25}>{book.game_no}</td>
                        <td style={tdStyle}>{book.ticket_number}</td>
                        <td style={tdStyle}>{book.value}</td>
                      </tr>
                    ))
                  : ""}
              </tbody>
            </table>
          </div>
        </div>

        {/* Lottery Tickets Section */}
        <div style={sectionStyle} className="section-container">
          <h3 style={titleStyle}>🎟 LOTTERY TICKETS</h3>
          <div style={{ overflowX: "auto" }}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Ticket No.</th>
                  <th style={thStyle}>Value</th>
                  <th style={thStyle}>Game Name</th>
                  <th style={thStyle}>Game Number</th>
                  <th style={thStyle}>Book Number</th>
                  <th style={thStyle}>Yesterday Ticket No</th>
                  <th style={thStyle}>Today Ticket No</th>
                  <th style={thStyle}>Quantity Sold</th>
                  <th style={thStyle}>Today Sold</th>
                </tr>
              </thead>
              <tbody>
                {printData.lottery_tickets !== undefined
                  ? printData.lottery_tickets.map((ticket, index) => (
                      <tr key={index}>
                        <td style={tdStyle}>{ticket.today_ticket_no}</td>
                        <td style={tdStyle}>{ticket.value}</td>
                        <td style={tdStyle}>{ticket.game_name}</td>
                        <td style={tdStyle}>{ticket.game_no}</td>
                        <td style={tdStyle}>{ticket.book_no}</td>
                        <td style={tdStyle}>{ticket.last_ticket_no}</td>
                        <td style={tdStyle}>{ticket.today_ticket_no}</td>
                        <td style={tdStyle}>{ticket.quantity_sold}</td>
                        <td style={tdStyle}>{ticket.today_sold}</td>
                      </tr>
                    ))
                  : ""}

                <tr>
                  <td
                    colSpan={7}
                    style={{ ...tdStyle, textAlign: "right", fontWeight: "bold" }}
                  >
                    Grand Total
                  </td>
                  <td style={tdStyle}>
                    <strong>{printData.grand_total_of_quantity_sold}</strong>
                  </td>
                  <td style={tdStyle}>
                    <strong>{printData.grand_total_of_today_sold}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  ) : (
    ""
  );
};

export default GetReport;